module.exports = __webpack_public_path__ + "img/platform-monitoring-data.62ae4ac2.png";